import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  DisclaimerText,
  DisclaimerTextSchema,
  DisclaimerTextValidation,
} from './DisclaimerTextExtension';

export const DisclaimerTextFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'DisclaimerText',
    component: DisclaimerText,
    schema: DisclaimerTextSchema,
    validation: DisclaimerTextValidation,
  }),
);
